/* src/app/umbrella-common/components/waiting-spinner/waiting-spinner.style.scss */
.spinner-section {
  display: flex;
}
.spinner-section .saving-icon-spin {
  margin-top: auto;
  margin-bottom: auto;
  padding-top: 4px;
  -webkit-animation: spin 1s linear infinite;
  -moz-animation: spin 1s linear infinite;
  animation: spin 1s linear infinite;
}
.spinner-section .saving-icon-static {
  margin-top: auto;
  margin-bottom: auto;
  padding-top: 4px;
}
.spinner-section .saving-caption {
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.33;
  color: #8C8C8C;
  padding-top: 4px;
  margin-top: auto;
  margin-bottom: auto;
  margin-left: 10px;
}
@media screen and (max-width: 479px) {
  .spinner-section .saving-caption.hide {
    display: none !important;
  }
}
/*# sourceMappingURL=waiting-spinner.style.css.map */
